import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../../shared/crud/form";

export const messages = defineMessages({
  ...defaultFormMessages,
  title: {
    id: "menu.promotions.editByExcel.title",
    defaultMessage: "Apply promotion to: {promotionId}",
  },
  description: {
    id: "promotions.editByExcel.description",
    defaultMessage: "Update promotion",
  },
  dropHere: {
    id: "app.imageManager.dropHere",
    defaultMessage: "Drop files here...",
  },
  row: {
    id: "promotions.editByExcel.row",
    defaultMessage: "Row",
  },
  reason: {
    id: "promotions.editByExcel.reason",
    defaultMessage: "Reason",
  },
  import: {
    id: "promotions.editByExcel.import",
    defaultMessage: "Import",
  },
  exportToExcel: {
    id: "promotions.editByExcel.exportToExcel",
    defaultMessage: "Download template",
  },
  processedSuccessfully: {
    id: "promotions.editByExcel.processedSuccessfully",
    defaultMessage: "Processed successfully",
  },
  errorsFound: {
    id: "promotions.editByExcel.errorsFound",
    defaultMessage: "rows with errors were found",
  },
  rawResult: {
    id: "promotions.editByExcel.rawResult",
    defaultMessage: "Raw result",
  },
});
